import React from 'react';
import {
  textUI,
  currentOrPastDateUI,
  currentOrPastDateSchema,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';

const uiSchema = {
  ...titleUI('Test name and date taken'),
  testName: {
    ...textUI({
      title: 'Name of test',
      required: () => true,
      errorMessages: {
        required: 'Enter the name of the test',
      },
    }),
  },
  testDate: {
    ...currentOrPastDateUI({
      title: 'Date test was taken',
      hint: "This date can't be in the future",
      required: () => true,
      monthSelect: false,
    }),
    'ui:errorMessages': {
      required: 'Enter the date you took the test',
      futureDate: 'You must enter a past or present date',
      pattern: 'Enter a valid date',
    },
  },
  'view:testNameQuickSubmitNote': {
    'ui:description': (
      <p
        className="vads-u-margin-top--4"
        data-testid="test-name-quicksubmit-note"
      >
        <strong>Note:</strong> When you submit this form on QuickSubmit or by
        mail, you’ll need to attach a copy of your test results to your
        submission. If you don’t have any test results but have a copy of your
        license or certification that clearly displays your name, you can attach
        that.
      </p>
    ),
    'ui:options': {
      hideIf: formData => formData?.['view:form0803BenefitsIntakeSubmission'],
    },
  },
  'view:testNameBenefitsIntakeNote': {
    'ui:description': (
      <p
        className="vads-u-margin-top--4"
        data-testid="test-name-benefits-intake-note"
      >
        <strong>Note:</strong> You will need to upload a copy of your test
        results to your submission. If you do not have any test results but have
        a copy of your license or certification that clearly displays your name,
        you can upload that.
      </p>
    ),
    'ui:options': {
      hideIf: formData => !formData?.['view:form0803BenefitsIntakeSubmission'],
    },
  },
};

const schema = {
  type: 'object',
  properties: {
    testName: {
      type: 'string',
    },
    testDate: currentOrPastDateSchema,
    'view:testNameQuickSubmitNote': { type: 'object', properties: {} },
    'view:testNameBenefitsIntakeNote': { type: 'object', properties: {} },
  },
  required: ['testName', 'testDate'],
};

export { schema, uiSchema };
